
import { MapLocation } from '@/types/location';

export const rotanaSignsLocations: MapLocation[] = [
  {
    id: 90001,
    name: 'SSM-001',
    type: 'Digital Unipole',
    devices: 1,
    coordinates: [30.973860, 41.022340],
    region: 'Arar',
    mediaOwner: 'Rotana Signs',
    mediaKind: 'Outdoor',
    screenType: 'Landscape Screens',
    orientation: 'Landscape',
    adminOnly: true,
    details: {
      resolution: '720x480',
      screenSpecifications: '5000-7500 nits',
      screenDimensions: '6m x 4m',
      numberOfFaces: 1,
      trafficType: 'Mixed',
      estimatedDailyImpressions: '49.0K',
      operatingHours: '18',
      adSlotDuration: '10',
      description: 'King Saudi Road x Prince Nayef Bin Abdulaziz Road Roundabout (T-Section)',
    },
  },
  {
    id: 90002,
    name: 'SSM-002',
    type: 'Digital Unipole',
    devices: 1,
    coordinates: [31.322520, 37.353060],
    region: 'Al Qurayyat',
    mediaOwner: 'Rotana Signs',
    mediaKind: 'Outdoor',
    screenType: 'Landscape Screens',
    orientation: 'Landscape',
    adminOnly: true,
    details: {
      resolution: '600x480',
      screenSpecifications: '5000-7500 nits',
      screenDimensions: '5m x 4m',
      numberOfFaces: 1,
      trafficType: 'Mixed',
      estimatedDailyImpressions: '49.0K',
      operatingHours: '18',
      adSlotDuration: '10',
      description: 'Al Madinah Al Munawarah Road x Makkah Al Mukarramah Road (outside King Fahad mosque)',
    },
  },
  {
    id: 90003,
    name: 'SSM-003',
    type: 'Digital Unipole',
    devices: 1,
    coordinates: [31.326690, 37.337540],
    region: 'Al Qurayyat',
    mediaOwner: 'Rotana Signs',
    mediaKind: 'Outdoor',
    screenType: 'Landscape Screens',
    orientation: 'Landscape',
    adminOnly: true,
    details: {
      resolution: '600x480',
      screenSpecifications: '5000-7500 nits',
      screenDimensions: '5m x 4m',
      numberOfFaces: 1,
      trafficType: 'Mixed',
      estimatedDailyImpressions: '49.0K',
      operatingHours: '18',
      adSlotDuration: '10',
      description: 'Umar Ibn Al Khattab Road before crossing Tabouk Road Intersection',
    },
  },
  {
    id: 90004,
    name: 'RYH-TAKH-PND-SG5',
    type: 'Smart Gate',
    devices: 1,
    coordinates: [24.676808, 46.676781],
    region: 'Riyadh',
    mediaOwner: 'Rotana Signs',
    mediaKind: 'Indoor',
    screenType: 'Landscape Screens',
    orientation: 'Landscape',
    adminOnly: true,
    details: {
      resolution: '2560x1792',
      screenSpecifications: '2500 nits',
      screenDimensions: '5m x 4m',
      numberOfFaces: 1,
      trafficType: 'Pedestrians',
      estimatedDailyImpressions: '119.0K',
      operatingHours: '18',
      adSlotDuration: '10',
      description: 'Panda - Hyper Market - Al Takhassousi Street',
    },
  },
  {
    id: 90005,
    name: 'JED-SRF-DNB-SG5',
    type: 'Smart Gate',
    devices: 1,
    coordinates: [21.56030509, 39.18489671],
    region: 'Jeddah',
    mediaOwner: 'Rotana Signs',
    mediaKind: 'Indoor',
    screenType: 'Landscape Screens',
    orientation: 'Landscape',
    adminOnly: true,
    details: {
      resolution: '2560x1536',
      screenSpecifications: '2500 nits',
      screenDimensions: '5m x 3m',
      numberOfFaces: 1,
      trafficType: 'Pedestrians',
      estimatedDailyImpressions: '77.0K',
      operatingHours: '18',
      adSlotDuration: '10',
      description: 'Danube - Hypermarket - Al Serafi Mall',
    },
  },
  {
    id: 90006,
    name: 'DMM-RAKAH-DNB-SG4',
    type: 'Smart Gate',
    devices: 1,
    coordinates: [26.36044176, 50.1891767],
    region: 'Eastern',
    mediaOwner: 'Rotana Signs',
    mediaKind: 'Indoor',
    screenType: 'Landscape Screens',
    orientation: 'Landscape',
    adminOnly: true,
    details: {
      resolution: '2048x1792',
      screenSpecifications: '2500 nits',
      screenDimensions: '4m x 3.5m',
      numberOfFaces: 1,
      trafficType: 'Pedestrians',
      estimatedDailyImpressions: '154.0K',
      operatingHours: '18',
      adSlotDuration: '10',
      description: 'Danube - Hypermarket - Ar Rakah',
    },
  },
  {
    id: 90007,
    name: 'JED-DAN-40 Street',
    type: 'Hyper Digital Screens',
    devices: 20,
    coordinates: [21.5641291, 39.1568224],
    region: 'Jeddah',
    mediaOwner: 'Rotana Signs',
    mediaKind: 'Indoor',
    screenType: 'Portrait Screens',
    orientation: 'Portrait',
    adminOnly: true,
    details: {
      resolution: '1080x1920',
      screenSpecifications: '400-550 nits',
      screenDimensions: '55 inches',
      numberOfFaces: 20,
      trafficType: 'Pedestrians',
      estimatedDailyImpressions: '49.0K',
      operatingHours: '18',
      adSlotDuration: '10',
      description: 'Danube - 40th Street',
    },
  },
  {
    id: 90008,
    name: 'RYH-DAN-HAYAT',
    type: 'Hyper Digital Screens',
    devices: 24,
    coordinates: [24.7432578, 46.6783695],
    region: 'Riyadh',
    mediaOwner: 'Rotana Signs',
    mediaKind: 'Indoor',
    screenType: 'Portrait Screens',
    orientation: 'Portrait',
    adminOnly: true,
    details: {
      resolution: '1080x1920',
      screenSpecifications: '400-550 nits',
      screenDimensions: '55 inches',
      numberOfFaces: 24,
      trafficType: 'Pedestrians',
      estimatedDailyImpressions: '77.0K',
      operatingHours: '18',
      adSlotDuration: '10',
      description: 'Riyadh - Al Hayat Mall',
    },
  },
  {
    id: 90009,
    name: 'KHO-FARMS-DANA',
    type: 'Hyper Digital Screens',
    devices: 12,
    coordinates: [26.3333149, 50.1465992],
    region: 'Eastern',
    mediaOwner: 'Rotana Signs',
    mediaKind: 'Indoor',
    screenType: 'Portrait Screens',
    orientation: 'Portrait',
    adminOnly: true,
    details: {
      resolution: '1080x1920',
      screenSpecifications: '400-550 nits',
      screenDimensions: '55 inches',
      numberOfFaces: 12,
      trafficType: 'Pedestrians',
      estimatedDailyImpressions: '49.0K',
      operatingHours: '18',
      adSlotDuration: '10',
      description: 'Farm Superstores - Dana Mall, Khobar',
    },
  },
];
